import { render, staticRenderFns } from "./customerCreditrecord.vue?vue&type=template&id=645968ec"
import script from "./customerCreditrecord.vue?vue&type=script&lang=js"
export * from "./customerCreditrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports